"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _iconsMaterial = require("@mui/icons-material");
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _TitledPaper = _interopRequireDefault(require("../../TitledPaper"));
var _DeleteIcon, _SaveIcon;
var Actions = function Actions(_ref) {
  var ActionsProps = _ref.ActionsProps,
    disabled = _ref.disabled,
    id = _ref.id,
    onDelete = _ref.onDelete,
    pristine = _ref.pristine;
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    justifyContent: "center",
    spacing: 1,
    wrap: "nowrap"
  }, onDelete && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    arrow: true,
    title: ActionsProps.deleteButtonTooltipText
  }, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    disabled: ActionsProps.deleteButtonDisabled,
    id: "".concat(id, "DeleteButton"),
    onClick: onDelete,
    size: "small"
  }, _DeleteIcon || (_DeleteIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.Delete, null))))), !disabled && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: "auto"
  }, /*#__PURE__*/_react.default.createElement(_material.Tooltip, {
    arrow: true,
    title: ActionsProps.saveButtonTooltipText
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    disabled: ActionsProps.saveButtonDisabled || pristine,
    id: "".concat(id, "SubmitButton"),
    size: "small",
    type: "submit"
  }, _SaveIcon || (_SaveIcon = /*#__PURE__*/_react.default.createElement(_iconsMaterial.Save, null)))))));
};
var defaultActionsProps = {
  deleteButtonDisabled: false,
  deleteButtonTooltipText: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "actions.delete"
  }),
  saveButtonDisabled: false,
  saveButtonTooltipText: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "actions.save"
  })
};
function FormBox(_ref2) {
  var _ref2$ActionsProps = _ref2.ActionsProps,
    ActionsProps = _ref2$ActionsProps === void 0 ? {} : _ref2$ActionsProps,
    children = _ref2.children,
    disabled = _ref2.disabled,
    id = _ref2.id,
    onDelete = _ref2.onDelete,
    pristine = _ref2.pristine,
    title = _ref2.title,
    titleKey = _ref2.titleKey;
  var isPhone = (0, _material.useMediaQuery)(function (theme) {
    return theme.breakpoints.down('sm');
  });
  return /*#__PURE__*/_react.default.createElement(_TitledPaper.default, {
    actions: /*#__PURE__*/_react.default.createElement(Actions, {
      ActionsProps: (0, _extends2.default)({}, defaultActionsProps, ActionsProps),
      disabled: disabled,
      id: id,
      onDelete: onDelete,
      pristine: pristine
    }),
    id: "".concat(id, "Model"),
    title: title,
    titleKey: titleKey
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 2
  }, children, isPhone && /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(Actions, {
    ActionsProps: (0, _extends2.default)({}, defaultActionsProps, ActionsProps),
    disabled: disabled,
    id: "".concat(id, "Phone"),
    onDelete: onDelete,
    pristine: pristine
  }))));
}
var _default = exports.default = FormBox;